/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: ulti.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/routers/ulti.js
 */

export const LoadComponent = (path) => () => import(`@/${path}.vue`)

export const LoadView = (name, index = false) =>
    LoadComponent(`resources/views/${name}${index ? '/index' : ''}`)

